export default "__VITE_ASSET__Zn$Xq0ay__"